import React from 'react';

import {FormikErrors, withFormik} from 'formik';

import {ConsigneeData, ConsigneeTerms} from 'commons/types/Types';
import ConsigneeInnerForm from './ConsigneeInnerForm';
import {getMinValueMessage, getMismatchMessage} from 'commons/utils/Messagefunctions';
import {setDefaultValue} from 'commons/utils/Functions';

type Props = {
    expedientId: number;
    consigneesConfig: ConsigneeTerms | undefined;
    submitHandler: (values: ConsigneeTerms) => void;
    consignees: Array<ConsigneeData>;
};

const FormControl = withFormik<Props, ConsigneeTerms>({
    mapPropsToValues: (props) => {
        const {consigneesConfig} = props;
        if (consigneesConfig) {
            return {
                expedientId: props.expedientId,
                hasConsignees: consigneesConfig.hasConsignees,
                hasAdminAccounts: consigneesConfig.hasAdminAccounts,
                numberConsignees: setDefaultValue(consigneesConfig.numberConsignees, ''),
            };
        } else {
            return {
                expedientId: props.expedientId,
                hasConsignees: false,
                hasAdminAccounts: false,
                numberConsignees: '',
            };
        }
    },
    validateOnBlur: false,
    validateOnChange: true,
    validate: (values: ConsigneeTerms, props) => {
        const errors: FormikErrors<ConsigneeTerms> = {};
        if (values.hasAdminAccounts && values.hasConsignees) {
            if (values.numberConsignees && values.numberConsignees.length) {
                if (Number(values.numberConsignees) < 1) {
                    errors.numberConsignees = getMinValueMessage('', 1);
                }
                if (isNaN(Number(values.numberConsignees))) {
                    errors.numberConsignees = getMismatchMessage();
                }
                if (Number(values.numberConsignees) < props.consignees.length) {
                    errors.numberConsignees = getMinValueMessage('', props.consignees.length);
                }
            } else {
                errors.numberConsignees = 'Campo requerido';
            }
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler(values);
    },
})(ConsigneeInnerForm);

export default function ConsigneeForm(props: Props) {
    const {submitHandler, expedientId, consigneesConfig, consignees} = props;
    return (
        <FormControl
            submitHandler={submitHandler}
            expedientId={expedientId}
            consigneesConfig={consigneesConfig}
            consignees={consignees}
        />
    );
}
